<template>
    <div
        class="cursor config-list"
        @click="showChildren = !showChildren"
    >
        <ConfigOption
            :key="configOption.name"
            :contract="contract"
            :config-option="configOption"
            :is-domain-transfer="isDomainTransfer"
            @restartTransfer="handleRestartTransfer"
        />
    </div>
    <div
        v-if="showChildren"
        class="config-list"
    >
        <ConfigOption
            v-for="childOption in configOption.children"
            :key="childOption.name"
            :contract="contract"
            :config-option="childOption"
            :should-indent="true"
            :is-domain-transfer="isDomainTransfer"
            @restartTransfer="handleRestartTransfer"
        />
    </div>
</template>

<script setup>

import ConfigOption from '~@/Components/Customers/Contracts/ConfigOption'
import { ref } from 'vue'

defineProps({
    configOption: {
        type: Object,
        default: () => { return {} }
    },
    contract: {
        type: Object,
        default: () => { return {} }
    },
    isDomainTransfer: {
        type: Boolean,
        default: () => { return false }
    }
})

const emit = defineEmits(['restartTransfer'])
const showChildren = ref(true)

const handleRestartTransfer = function () {
    emit('restartTransfer')
}

</script>

<style scoped>
.cursor {
    cursor: pointer;
}
.config-list {
    display: block !important;
    grid-gap: 0 !important;

    & > div {
        display: grid !important;
        grid-template-columns: 2fr 2fr 2fr;
        grid-gap: 15px;
        align-items: center;

        &.two-columns {
            grid-template-columns: 1fr 2fr 0fr;
        }

        & span:nth-child(1) {
            font-weight: bold;
        }

        & span:nth-child(2) {
            line-height: 1.5em;
            word-break: break-all;
        } & button {
              justify-self: end;
              & span {
                  font-weight: normal !important;
              }
          }
    }
}
</style>
